export const blockIconsPhotoandimageAddAPhotoNew = (
	<span className='material-symbols-outlined'>add_a_photo</span>
);
